/**
 * SuggestionChips — список clickable-подсказок «как начать диалог».
 *
 * Stacked variant (default, drawer): full-width карточки с иконкой 28×28 слева,
 *   текстом, стрелкой ArrowUpRight справа. Иконка цветится accent'ом, на hover
 *   inverts.
 * Inline variant (widget): pill-row без иконок и стрелок, компактно.
 *
 * Props:
 *   items     — Array<string | { text, icon }>. `icon` — Lucide-компонент.
 *               Default иконка для stacked — Sparkles.
 *   onPick    — (text) => void
 *   disabled  — boolean
 *   variant   — 'stacked' | 'inline'
 *   label     — string (опц., uppercase подпись над списком)
 */

import { ArrowUpRight, Sparkles } from 'lucide-react'

function normalize(item) {
    if (typeof item === 'string') return { text: item, icon: Sparkles }
    return { text: item.text, icon: item.icon || Sparkles }
}

export default function SuggestionChips({
    items = [],
    onPick,
    disabled = false,
    variant = 'stacked',
    label = null,
}) {
    if (!items.length) return null

    const isInline = variant === 'inline'
    const normalized = items.map(normalize)

    return (
        <>
            {label && !isInline ? (
                <div className="conversation__empty-suggest-label">{label}</div>
            ) : null}
            <div
                className={
                    'conversation__chips' +
                    (isInline ? ' conversation__chips--inline' : '')
                }
            >
                {normalized.map((s, i) => {
                    const Ico = s.icon
                    return (
                        <button
                            key={i}
                            type="button"
                            className="conversation__chip"
                            onClick={() => onPick?.(s.text)}
                            disabled={disabled}
                        >
                            {!isInline ? (
                                <span
                                    className="conversation__chip-icon"
                                    aria-hidden="true"
                                >
                                    <Ico size={14} />
                                </span>
                            ) : null}
                            <span className="conversation__chip-text">{s.text}</span>
                            {!isInline ? (
                                <ArrowUpRight
                                    size={14}
                                    className="conversation__chip-arrow"
                                    aria-hidden="true"
                                />
                            ) : null}
                        </button>
                    )
                })}
            </div>
        </>
    )
}
